import { ButtonLoaderComponent } from './button-loader.component';

export default angular
  .module('sfMobile.components.button-loader', [])
  .component('sfButtonLoader', ButtonLoaderComponent).name;
